import {
    /** FETCH APPLICATION  */
    FETCH_APPLICATIONNOTEFULLHISTORY_FULFILLED,
    FETCH_APPLICATIONNOTEFULLHISTORY_REJECTED,
    FETCH_APPLICATIONNOTEFULLHISTORY_PENDING,
    RESET_APPLICATIONNOTEFULLHISTORY
} from "../../actions/nurse/applicationNoteFullHistory";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPLICATIONNOTEFULLHISTORY_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_APPLICATIONNOTEFULLHISTORY_FULFILLED:
            return {
                ...state,
                applicationNoteFullHistory: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_APPLICATIONNOTEFULLHISTORY_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_APPLICATIONNOTEFULLHISTORY:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};